import { ID } from "@libs/interfaces/layouts";
import { ILand } from "@/modules/pe-fest-module/data/interfaces";
import useLands from "@/modules/pe-topos-module/hooks/useLands";
import { IState, useMainStore } from "@/settings/zustand";
import { useEffect, useState } from "react";
import { useDataStore } from "../data/store";
import { useParams } from "react-router";


export default function useLand() {
    const {landId} = useParams()
    const _landId : ID = useMainStore((state:IState) => state.landId )
    const lands:ILand[] = useDataStore((state: any) => state.Land || [])
    useLands()
    const [land, setLand] = useState<ILand>({} as ILand)
    useEffect(() => {
        setLand(() => {
            const l = lands.find(lnd => lnd.id === landId) ||  lands.find(lnd => lnd.id === _landId) || {} as ILand
            return l
        })
    }, [landId, lands])
    return land
}